"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import { AppDispatcher } from 'Dispatcher';
import router from 'Router';
import StoreClass from 'Store';
import { LoginFormConstants } from 'Constants/Login/LoginFormConstants';
import request from 'superagent';
import md5 from 'js-md5';
import { showSnackBar } from 'Actions/D5SnackbarsActions';
import { setDocumentTitle } from 'Actions/ApplicationActions';
import { Messages } from "Messages";
import { deleteAllCookies } from "D5Utils/functions";
import { System } from "Constants/objects";
var _store = {
  isLoginValid: true,
  isPassValid: true,
  login: '',
  password: ''
};
var CHANGE_EVENT = 'change';

var LoginFormStoreClass =
/*#__PURE__*/
function (_StoreClass) {
  _inherits(LoginFormStoreClass, _StoreClass);

  function LoginFormStoreClass() {
    _classCallCheck(this, LoginFormStoreClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(LoginFormStoreClass).apply(this, arguments));
  }

  _createClass(LoginFormStoreClass, [{
    key: "doValidate",

    /**
     * @param {string} login
     * @param {string} pass
     */
    value: function doValidate(login, pass) {
      _store.login = login;
      _store.password = pass;
      _store.isLoginValid = _store.login.trim().length && !_store.login.match(/\s/);
      _store.isPassValid = _store.password.trim().length && _store.password.length > 5;
    }
  }, {
    key: "doLogin",
    value: function doLogin() {
      var _request$post$send,
          _this = this;

      request.post('/wapi/login').send((_request$post$send = {}, _defineProperty(_request$post$send, System.login, _store.login), _defineProperty(_request$post$send, "password", md5(_store.password)), _request$post$send)).then(function (res) {
        var returnUrl = _this.getReturnUrl();

        if (res.status >= 200 && res.status < 300) {
          if (res.body.ResponseCode && res.body.ResponseCode !== '000') {
            showSnackBar({
              type: System.SNACKBAR_TYPES.Error,
              message: res.body.ResponseText
            });
          } else {
            localStorage.setItem(System.current_user, JSON.stringify(res.body.Response));
            router.navigateTo(returnUrl);
          }
        } else {
          showSnackBar({
            type: System.SNACKBAR_TYPES.Error,
            message: 'Connection error'
          });
        }
      });
    }
  }, {
    key: "getReturnUrl",
    value: function getReturnUrl() {
      var returnUrl = localStorage.getItem(System.ReturnUrl);
      returnUrl = [System.login, System.page404].includes(returnUrl) ? '' : returnUrl;
      return returnUrl;
    }
  }, {
    key: "doLogout",
    value: function doLogout() {
      request.post("".concat(router.getAPIUrl(), "/logout")).then(function () {
        deleteAllCookies();
        localStorage.removeItem(System.current_user);
        localStorage.setItem(System.ReturnUrl, window.location.hash.slice(1));
        router.navigateTo(System.login);
        setDocumentTitle();
      });
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return _store.isLoginValid && _store.isPassValid;
    }
  }, {
    key: "getList",
    value: function getList() {
      return _objectSpread({}, _store);
    }
  }]);

  return LoginFormStoreClass;
}(StoreClass);

var LoginFormStore = new LoginFormStoreClass();
AppDispatcher.register(function (action) {
  switch (action.actionType) {
    case LoginFormConstants.DO_LOGIN:
      LoginFormStore.doValidate(action.login, action.password);
      if (LoginFormStore.isValid()) LoginFormStore.doLogin();
      LoginFormStore.emit(CHANGE_EVENT);
      break;

    case LoginFormConstants.DO_LOGOUT:
      LoginFormStore.doLogout();
      LoginFormStore.emit(CHANGE_EVENT);
      break;

    default:
      return true;
  }
});
export default LoginFormStore;